/**
 *
 * Node = {
 *   data,
 *   children,
 *   hash,
 * }
 *
 * hash(node) = hash(data) + for all child in childs: hash(child)
 *
 * if hash(n1) == hash(n2), then n1 and n2 are the same tree
 */

const Node = function(data, hashFn) {
  this.children = [];
  this.data = data;
  this.hashFn = hashFn;

  this.updateHash();
};

Node.prototype = {
  getData: function() {
    return this.data;
  },

  updateHash: function() {
    this.hash = this.hashFn(this.data, this.children.map(child => child.getHash()));
  },

  updateData: function(newData) {
    this.data = newData;
  },

  appendChild: function(child) {
    if (!(child instanceof Node)) {
      throw new Error(`child "${child}" is not instance of merkle tree Node`);
    }

    this.children.push(child);
  },

  prependChild: function(child) {
    this.children.unshift(child);
  },

  removeChildByIndex: function(index) {
    if (index < 0 || index >= this.children.length) {
      throw new Error(`removeChildByIndex index ${index} is out of range`);
    }

    this.children = this.children.slice(0, index).concat(this.children.slice(index + 1));
  },

  removeChildByRange: function(start, end) {
    if (start < 0 || start >= this.children.length) {
      throw new Error(`start ${start} is out of range`);
    }
    if (end < 0 || end >= this.children.length) {
      throw new Error(`start ${end} is out of range`);
    }
    if (start > end) {
      throw new Error(`start ${start} is bigger than end ${end}`);
    }

    const newChildren = [];

    for (let i = 0; i < this.children.length; i++) {
      if (i < start || i > end) {
        newChildren.push(this.children[i]);
      }
    }

    this.children = newChildren;
  },

  removeAllChildren: function() {
    this.children = [];
  },

  replaceChildByIndex: function(index, newChild) {
    if (index < 0 || index >= this.children.length) {
      throw new Error(`removeChildByIndex index ${index} is out of range`);
    }

    this.children = this.children.slice(0, index).concat([newChild]).concat(this.children.slice(index + 1));
  },

  getChildByIndex: function(index) {
    if (index < 0 || index >= this.children.length) {
      throw new Error(`removeChildByIndex index ${index} is out of range`);
    }
    return this.children[index];
  },

  findNodeByPath: function(path) {
    let cur = this;

    for (let i = 0; i < path.length; i++) {
      cur = cur.getChildByIndex(path[i]);
    }

    return cur;
  },

  getHash: function() {
    return this.hash;
  },

  clone: function() {
    const node = new Node(this.data, this.hashFn);
    node.children = this.children.slice(0); // TODO opt

    node.hash = this.hash;
    return node;
  },
};

// update hash by path
const updateHashByPath = (root, path) => {
  const nodes = [];
  let cur = root;
  for (let i = 0; i < path.length; i++) {
    const next = cur.getChildByIndex(path[i]);
    nodes.push(next);
    cur = next;
  }

  nodes.unshift(root);

  for (let i = nodes.length - 1; i >= 0; i--) {
    nodes[i].updateHash();
  }
};

export {
  Node,
  updateHashByPath,
};
